var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconETicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 4h4V2h-6v6h2V4zm0 20h-2v6h6v-2h-4v-4zm20 4h4v-4h2v6h-6v-2zm0-26v2h4v4h2V2h-6zm-12 14v2h4v2h-2v4h-6v-6h2v-2h2zm4 0v2h2v2h2v4h2v-2h2v-2h-4v-4h-4zm-2-2v2h2v-2h-2zm0 0h-6V8h6v2h2v2h-2v2zm-4 8h2v-2h-2v2zm2-10h-2v-2h2v2zm4 10h2v2h-2v-2zm6-6v2h2V8h-6v6h4v2zm-2-4v-2h2v2h-2z",
    fill: "#54822B"
  })));
}

export default SvgIconETicket;